import React, {useContext} from 'react';
import styled from '@emotion/styled';
import { breakpoints } from '../../utils/style';
import ButtonLink from '../shared/ButtonLink';
import {LogoutButton} from '../Auth/Auth';
import StoreContext from "../shared/Context/StoreContext";

const HeaderContacts = styled('div')`
  flex-basis: 55%;
  text-align: right;
  padding-top: 13px;
  .header-search-wrapper {
    display: inline-block;
    width: 200px;
  }
  .header-contact-group {
    display: inline-block;
    vertical-align: top;
    .button {
      padding: 9px 23px 5px;
      margin: 0 25px;
      font-size: 1.1rem;
      text-align: left;
      display: inline-block;
      vertical-align: middle;
    }
    .green-button {
      float: right;
      margin: 0;
      span {
        font-size: 16px;
        font-weight: bold;
        display: inline-block;
        vertical-align: baseline;
      }
    }
    .register-button {
      height: 47px;
      width: 178px;
      text-align: center;
      span {
        display: inline-block;
        vertical-align: middle;
        margin-top: 2px;
        line-height: 22px;
      }
      &:hover, &:active {
        padding: 10px 23px 6px;
      }
    }
    .logout-button {
      height: auto;
      padding: 14px 23px;
      width: 178px;
      text-align: center;
      svg {
        margin-left: 7px;
        vertical-align: top !important;
      }
    }
    
  }
  .header-image-wrap, .button {
    display: inline-block;
    vertical-align: top;
    margin-bottom: 20px;
  }
  .header-image-wrap .gatsby-image-wrapper {
    border-radius: 100%;
  }
  .popup-content {
    text-align: center;
  }
  
  @media (max-width: ${breakpoints.lg}) {
    flex-basis: 63%;
    .header-contact-group {
      .button {
        margin: 0 5px;
      }
    }
  }
  
  @media (max-width: ${breakpoints.md}) {
    display: none;
    .header-contact-group {
      display: none;
    }
    .header-search-wrapper {
      display: block;
      width: 100%;
      position: relative;
      .close-menu {
        position: absolute;
        top: 22px;
        right: 5px;
        background: none;
      }
    }
  }
`;


export default ({ children }) => {
  const value = useContext(StoreContext);
  const username = value.username;
  return(
  <HeaderContacts id="header-contacts-menu" className="header-contacts-menu">
    {children}
    <div className="header-contact-group">
      <ButtonLink to={process.env.LINE_ID} text={process.env.LINE_ID_TEXT} external={true} className="button green-button"
                  iconName="line" iconSize={30} ariaText="Line" iconLeft={true} />

      {username ?
        <LogoutButton/> :
        <a className="button transparent-button register-button"
           href="/register/?register_type=onsitegames"
           aria-label="สมัครสมาชิก">
          <span>สมัครสมาชิก</span>
        </a>
      }
    </div>
  </HeaderContacts>
)};
